export const GOLD_AWARD_THRESHOLD = 0.85;
export const SILVER_AWARD_THRESHOLD = 0.6;
